var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsIconselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08203 9.91634V7.58301",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.91634V4.08301",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 9.91699V6.41699",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45703 6.99967C1.45703 4.38731 1.45703 3.08113 2.26859 2.26956C3.08015 1.45801 4.38633 1.45801 6.9987 1.45801C9.61104 1.45801 10.9172 1.45801 11.7288 2.26956C12.5404 3.08113 12.5404 4.38731 12.5404 6.99967C12.5404 9.61202 12.5404 10.9182 11.7288 11.7298C10.9172 12.5413 9.61104 12.5413 6.9987 12.5413C4.38633 12.5413 3.08015 12.5413 2.26859 11.7298C1.45703 10.9182 1.45703 9.61202 1.45703 6.99967Z",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIconselected);
export default __webpack_public_path__ + "static/media/analyticsIconselected.feadcb315df3b2f8581d099a32fd6807.svg";
export { ForwardRef as ReactComponent };